import { Action } from "../components/Actions";
import { EditorialShell } from "../components/EditorialShell";
import { master } from "../data";
import { albumByName } from "../data/albums";
import { toDisplayCopy } from "../logic/dimensions";
import type { OfficialResult, Song } from "../types";

export function OfficialResultSongsScreen({ result, onBack, onCreateCard }: { result: OfficialResult; onBack(): void; onCreateCard(): void }) {
  const expandedNames = new Set(result.expandedSongs.map((item) => item.song.song));
  const compactSongs = master.completed_albums
    .map((album) => result.selectedSongs.find((song) => song.album === album))
    .filter((song): song is Song => Boolean(song && !expandedNames.has(song.song)));

  return (
    <EditorialShell className="result-songs-page">
      <section className="songs-result-layout result-page-enter result-page-enter--forward" aria-labelledby="result-songs-title">
        <header className="songs-result-heading">
          <h1 id="result-songs-title">你的九首歌</h1>
          <p>这九首歌，和你的结果怎么连在一起。</p>
        </header>

        <section className="key-song-section" aria-label="三首重点歌曲">
          <div className="key-song-editorial">
            {result.expandedSongs.map((item, index) => (
              <article key={`${item.song.album}-${item.song.song}`}>
                <div className="key-song-identity">
                  <img src={albumByName.get(item.song.album)?.cover} alt={`${item.song.album} 专辑封面`} />
                  <div>
                    <span className="song-number">{String(index + 1).padStart(2, "0")}</span>
                    <h2>{item.song.song}</h2>
                    <span className="key-song-album">{item.song.album}</span>
                  </div>
                </div>
                <p>{toDisplayCopy(item.song.base_reading)}</p>
                {item.branchCopy ? <p className="song-branch">{toDisplayCopy(item.branchCopy)}</p> : null}
              </article>
            ))}
          </div>
        </section>

        <section className="compact-song-section" aria-label="其余歌曲">
          <ol className="compact-song-list">
            {compactSongs.map((song, index) => (
              <li key={`${song.album}-${song.song}`}>
                <span>{String(index + result.expandedSongs.length + 1).padStart(2, "0")}</span>
                <strong>{song.song}</strong>
                <p>{toDisplayCopy(song.compact)}</p>
              </li>
            ))}
          </ol>
        </section>

        {result.comboRule ? (
          <aside className="combo-note">
            <h2>还有一件事</h2>
            <p>{toDisplayCopy(result.comboRule.copy)}</p>
          </aside>
        ) : null}

        <div className="songs-result-actions">
          <Action tone="text" onClick={onBack}>← 回到人格结果</Action>
          <Action onClick={onCreateCard}>生成结果卡片</Action>
        </div>
      </section>
    </EditorialShell>
  );
}
